import React, { useState } from 'react';
import { useStytchB2BClient } from '@stytch/react/b2b';

console.log('🔄 PENDING-APPROVAL: Component loaded');

const PendingApproval = () => {
  console.log('🔍 PENDING-APPROVAL: Rendering');
  const stytch = useStytchB2BClient();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await stytch.session.revoke();
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleRefresh = () => {
    try { localStorage.setItem('lumoz-last-reload-reason', JSON.stringify({ reason: 'pending-approval-check', at: Date.now() })); } catch {}
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="text-6xl mb-6">⏳</div>

        {/* Heading */}
        <h1 className="text-3xl font-bold text-text-primary mb-4">
          Access Pending
        </h1>

        {/* Message */}
        <p className="text-text-secondary mb-2">
          Your request is awaiting admin approval.
        </p>

        <p className="text-text-muted text-sm">
          We've notified the organization administrators.
          Once approved, refresh this page to access the dashboard.
        </p>

        {/* Action Buttons */}
        <div className="mt-8 space-y-3">
          <button
            onClick={handleRefresh}
            className="w-full bg-accent-primary-base text-text-inverse py-2 px-6 rounded-full font-medium hover:bg-accent-primary-vibrant transition-colors"
          >
            Check Status
          </button>

          <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="w-full border border-border-subtle text-text-secondary py-2 px-6 rounded-full font-medium hover:bg-background-secondary transition-colors disabled:opacity-50"
          >
            {isLoggingOut ? 'Signing out...' : 'Sign Out'}
          </button>
        </div>

        {/* Info Box */}
        <div className="mt-8 bg-background-secondary border border-accent-lavender/30 rounded-lg p-4">
          <p className="text-text-muted text-xs">
            You're signed in but waiting for approval. Click "Check Status" after an admin approves your request.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
